module.exports = new __parcel__URL__("icon-plus.e6904ca9.svg").toString();